// Dependencies
import React from 'react'
import FileOpenIcon from '@mui/icons-material/FileOpen';
// Components from Dependency
import { PdfsDropZoneComponent } from '../../../ui/PdfsDropZoneComponent/PdfsDropZoneComponent';

const DemandFormatSolicitudViolencia = () => {
  return (
    <div className='w-full m-auto p-3'>      
      {/* Parte del componente que tiene las instrucciones en texto y descarga de documento*/}
      <div className='p-2'>
        <div className='flex justify align-items-center gap-2 h-auto'>
          <FileOpenIcon className="pi pi-file" style={{'fontSize': '2em', "color": "#e14b87"}} />
          <a href='./../../../../assets/pdf/solicitudViolencia/formatoDemanda.pdf' download className='hyperlink text-2xl'>Descarga el formato de demanda aquí.</a>
        </div>
        <p className='text-lg mt-2 pb-2 hyperlink__text'>Si no cuentas con escrito de un abogado, es necesario llenar el formato.</p>
      </div>

      <PdfsDropZoneComponent formValue="demandingFiles" MAX_FILES_SIZE={10} />

    </div>
  )
}

export {DemandFormatSolicitudViolencia}